<template>
    <div>
        <Login :product_name="product_name" />
    </div>
</template>

<script>
import {Login} from '@digicollect_front_end/digi-fe-library'
export default {
    data(){
        return {
            product_name: 'DigiHelp'
        }
    },
    components: {
        Login
        // 'digi-login': DigiCollectLibrary.Login
    },
    methods: {
        
    },
    computed: {

    },
}
</script>

<style scoped>

</style>